export function ucFirst(pattern:string){
    return pattern.charAt(0).toUpperCase() + pattern.slice(1)
}